import { Injectable } from "@angular/core";
import { App } from "@capacitor/app";
import { Capacitor } from "@capacitor/core";
import { ModalController } from "@ionic/angular";
import { initializeApp } from "firebase/app";
import { fetchAndActivate, getRemoteConfig, getValue } from "firebase/remote-config";
import { MmUpdateAppComponent } from "src/app/components/mm-update-app/mm-update-app.component";
import { environment } from "src/environments/environment.prod";
import { FlagsService } from "./flags.service";

/**
 * Classe responsavel pelo gerenciamento do Remoteconfig
 * @author Starley Cazorla
 */

@Injectable({
    providedIn: 'root'
})
export class RemoteConfigService {

    private isChecking = false;

    constructor(private flagsService: FlagsService,
        private modalCtrl: ModalController) { }

    /**
      * Inits firebase config
      * @author Starley Cazorla
      */
    async checkRemoteUpdateVersion() {
        if (this.isChecking) {
            return;
        }
        this.isChecking = true;

        let app = initializeApp(environment.firebaseConfig);
        let remoteConfig = getRemoteConfig(app);

        remoteConfig.settings.minimumFetchIntervalMillis = 30000;

        await fetchAndActivate(remoteConfig)
            .then(async () => {
                const versionNumber = await this.getVersionCode();

                this.flagsService.flag_manutencao_qualidade_bl = getValue(remoteConfig, 'flag_manutencao_qualidade_bl').asBoolean();
                this.flagsService.msg_manutencao = getValue(remoteConfig, 'msg_manutencao').asString();

                //For Menu service
                const menuRemote = getValue(remoteConfig, 'disable_or_hidden_menu').asString();
                console.log("🚀 ~ UpdateAppService ~ .then ~ menuRemote:", menuRemote);
                if (menuRemote) {
                    this.flagsService.disable_or_hidden_menu = JSON.parse(menuRemote);
                }

                //For Our Contact service
                this.flagsService.our_contact = getValue(remoteConfig, 'our_contact').asString();

                const otaLiveApp = getValue(remoteConfig, 'ota_live_app').asString();
                if (otaLiveApp) {
                    this.flagsService.ota_live_app = JSON.parse(otaLiveApp);
                }

                const updateAppByVersion = getValue(remoteConfig, 'update_app_by_version').asString();
                if (updateAppByVersion) {
                    this.flagsService.update_app_by_version = JSON.parse(updateAppByVersion);
                }

                const updateConfig = this.flagsService.update_app_by_version;
                if (updateConfig.active) {
                    const remoteVersion = parseInt(updateConfig.version.replace(/\./g, ''));
                    if (remoteVersion > parseInt(versionNumber)) {
                        setTimeout(async () => {
                            await this.showModalUpdateApp(updateConfig.force_update);
                        }, 5000);
                    }
                }

            })
            .catch((err) => {
                console.log('error: ', err);
            })
            .finally(() => {
                this.isChecking = false;
            });
    }

    async getVersionCode(): Promise<string> {
        const fallback = '999';
        if (Capacitor.isNativePlatform()) {
            return await App.getInfo()
                .then((code: any) => {
                    return code.version.toString().replace(/\./g, '');
                })
                .catch((error: any) => {
                    console.log('getVersionCode: ', error);
                    return fallback;
                });
        } else {
            return fallback;
        }
    }

    async showModalUpdateApp(forceUpdate: boolean = false) {
        if (Capacitor.getPlatform() === 'web') {
            return;
        }
        const modal = await this.modalCtrl.create({
            component: MmUpdateAppComponent,
            cssClass: 'modalInterno',
            backdropDismiss: !forceUpdate,
            componentProps: {
                fromOta: false
            }
        });
        await modal.present();
    }


}
